import ExtendedPath from "csi/core/ExtendedPath";
import { Context } from "csi/def/Context";
import Heading from "csi/def/Heading";
import StringSelection from "csi/heading/StringSelection";
import locale from "csi/locale";
import reflection from "csi/reflection";
import xml from "csi/xml";
import Store from "dojo/store/api/Store";
import Memory from "dojo/store/Memory";
import declare from "dojo/_base/declare";

const enumTypes = [xml.ATTR_ENUM, xml.ATTR_ENUMLIST];

const UserDefaultTargetAttributeIdRenderer = declare(StringSelection, {
	getStore(ctx: Context, h: Heading): Store<object, object, object> {
		const formNode = ctx.getNode();
		const { DefaultAttribute, TargetClass, TargetAttributePath } = formNode;
		const data = [{ id: "", name: "" }];

		if (TargetClass && DefaultAttribute) {
			const ep = ExtendedPath.create(TargetClass, TargetAttributePath);
			if (ep) {
				const attributes = ep.getEndClass().getAttributes(false, true);
				const { format: defaultFormat, valueType } = reflection.getTypeAttribute("UserDefaults", DefaultAttribute);
				const typeBase = xml.attributeTypeGetBase(valueType) || valueType;
				const allowTypes = (typeBase == xml.ATTR_ENUM) ? enumTypes : [xml.ATTR_BOOLEAN];

				attributes.forEach((rca) => {
					const { attributeId, format, valueType } = rca;

					if (allowTypes.includes(valueType) && (!enumTypes.includes(valueType) || defaultFormat === format)) {
						data.push({ id: attributeId, name: locale.typeId(TargetClass, attributeId) });
					}
				});
			}
		}

		return new Memory({
			data,
			idProperty: "id",
			labelProperty: "name",
		});
	},
});

export = UserDefaultTargetAttributeIdRenderer;